import React, { useRef, useEffect, useState } from "react";
import "./trust.css";
import img1 from "../../assets/trust-img1.png";
// import img2 from "../../assets/trust-img2.png"
import img2 from "../../assets/trust-img22.png";
import img3 from "../../assets/trust-img3.png";
import img1Top from "../../assets/trust-img1-top.png";
// import img2Top from "../../assets/trust-img2-top.png"
import img2Top from "../../assets/trust-img22-top.png";
import img3Top from "../../assets/trust-img3-top.png";
import useWindowSize from "../../utils/useWindowSize";
import Trustslider from "./Trustslider";

const Trust = () => {
  const { width } = useWindowSize();
  const isPhone = width < 851;

  const trustData = [
    {
      id: 1,
      title: "DRDO",
      img: img1,
      imgTop: img1Top,
      bg: "#DAECFF",
      border: "1px solid #0351A1",
    },
    {
      id: 2,
      title: "Travel Trial",
      img: img2,
      imgTop: img2Top,
      bg: "#FFEADE",
      border: "1px solid #F36D24",
    },
    {
      id: 3,
      title: "Railtel",
      img: img3,
      imgTop: img3Top,
      bg: "#DBF3FF",
      border: "1px solid #0093DD",
    },
  ];

  return (
    <div className="boxWrapper trustboxwrapper">
      <div className="trustinnerDiv">
        <div className="trustTop">
          <h1 className="trustHeading">
            Trusted by Employees at RailTail, DRDO, and{" "}
            <span className="spanTrust">180+ Global Organizations</span>
          </h1>
        </div>

        {isPhone ? (
          <Trustslider />
        ) : (
          <div className="trustBottom">
            {trustData?.map((item) => (
              <div
                key={item.id}
                className="trustItem"
                style={{ backgroundColor: item.bg, border: item.border }}
              >
                <img className="trustImg" src={item.img} alt={item.title} />
                <img
                  className="trustImgTop"
                  src={item.imgTop}
                  alt={item.title}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Trust;
